import { render, staticRenderFns } from "./GroupInspectActions.vue?vue&type=template&id=8a454474&"
import script from "./GroupInspectActions.vue?vue&type=script&lang=js&"
export * from "./GroupInspectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports